import { useEffect, useState } from "react";
import "@/App.css";
import { AnimatePresence } from "framer-motion";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Lenis from "lenis";
import WhatsAppButton from "@/components/nesha/WhatsAppButton";
import AdminPage from "@/pages/AdminPage";
import ErrorBoundary from "@/components/nesha/ErrorBoundary";
import Preloader from "@/components/nesha/Preloader";
import Navbar from "@/components/nesha/Navbar";
import Hero from "@/components/nesha/Hero";
import About from "@/components/nesha/About";
import Products from "@/components/nesha/Products";
import Certificate from "@/components/nesha/Certificate";
import Contact from "@/components/nesha/Contact";
import Footer from "@/components/nesha/Footer";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2300);
    return () => clearTimeout(t);
  }, []);

  return (
    <ErrorBoundary>
      <div className="bg-cream font-body text-charcoal">
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <AnimatePresence>{loading && <Preloader key="preloader" />}</AnimatePresence>
                  <Navbar />
                  <main>
                    <Hero ready={!loading} />
                    <About />
                    <Products />
                    <Certificate />
                    <Contact />
                  </main>
                  <Footer />
                  <WhatsAppButton />
                </>
              }
            />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;
